import styled from "styled-components";

export default function WizardSelect({ label, value, onChange, options, placeholder }) {
  return (
    <Field>
      {label && <Label>{label}</Label>}
      <Select value={value || ""} onChange={(e) => onChange(e.target.value)}>
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </Select>
    </Field>
  );
}

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Label = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #374151;
`;

const Select = styled.select`
  padding: 10px 14px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 15px;
  font-family: inherit;
  outline: none;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s;

  &:focus {
    border-color: #182941;
    box-shadow: 0 0 0 2px rgba(24, 41, 65, 0.1);
  }
`;
